import { items } from "fusioncharts";
import { formatCurrency } from "util/format";
import moment from "moment";
moment.locale("pt-br");

export const mountChartProfit = (profit, profitPerCent) => {
  let dataSource = {
    chart: {
      subcaption: formatCurrency(profit),
      lowerlimit: "0",
      upperlimit: "100",
      showvalue: "1",
      numbersuffix: "%",
      theme: "gammel",
    },
    colorrange: {
      color: [
        {
          minvalue: "0",
          maxvalue: profitPerCent,
          code: "#2A8DEB",
        },
        {
          minvalue: profitPerCent,
          maxvalue: "100",
          code: "#BCBCBC",
        },
      ],
    },
    dials: {
      dial: [
        {
          value: profitPerCent,
        },
      ],
    },
  };
  return dataSource;
};

export const mountChartPie = (data, title, color, colorChart) => {
  let dataSource = {
    chart: {
      bgColor: color,
      showpercentvalues: "1",
      aligncaptionwithcanvas: "0",
      showLabels: "1",
      captionpadding: "0",
      showlegend: "0",
      exportEnabled: "1",
      exportFileName: title,
      numberPrefix: "R$ ",
      //Disabling number scale compression
      formatNumberScale: "0",
      //Defining custom decimal separator
      decimalSeparator: ",",
      //Defining custom thousand separator
      thousandSeparator: ".",
      theme: "gammel",
    },
    data: mountDataPie(data),
  };
  return dataSource;
};
const mountDataPie = (data) => {
  const Arrylabel = [];
  if (data) {
    data.forEach((data) => {
      Arrylabel.push({
        label: data.name,
        value: data.value,
      });
    });
  }
  return Arrylabel;
};

export const mountChartProfitBar = (res, title) => {
  const data = [];
  const dateFormat = "MMM/YYYY";
  for (let index = 1; index < 13; index++) {
    if (index < 10) {
      const month = moment(moment().year() + "-0" + index).format(dateFormat);
      var name = month.substring(0, 3);
      const firstLetter = name.charAt(0);

      const firstLetterCap = firstLetter.toUpperCase();

      const remainingLetters = name.slice(1);

      const capitalizedWord = firstLetterCap + remainingLetters;
      const hasMonth = res.filter((item) => item.month == capitalizedWord);
      var revenue = 0;
      var expense = 0;
      var profit = 0;
      if (hasMonth.length == 1) {
        revenue = hasMonth[0].revenue;
        expense = hasMonth[0].expense;
        profit = hasMonth[0].profit;
      }
      data.push({
        month: capitalizedWord,
        revenue: revenue,
        expense: expense,
        profit: profit,
      });
    } else {
      const month = moment(moment().year() + "-" + index).format(dateFormat);
      var name = month.substring(0, 3);
      const firstLetter = name.charAt(0);

      const firstLetterCap = firstLetter.toUpperCase();

      const remainingLetters = name.slice(1);

      const capitalizedWord = firstLetterCap + remainingLetters;
      const hasMonth = res.filter((item) => item.month == capitalizedWord);
      var revenue = 0;
      var expense = 0;
      var profit = 0;
      if (hasMonth.length == 1) {
        revenue = hasMonth[0].revenue;
        expense = hasMonth[0].expense;
        profit = hasMonth[0].profit;
      }
      data.push({
        month: capitalizedWord,
        revenue: revenue,
        expense: expense,
        profit: profit,
      });
    }
  }
  let dataSource = {
    chart: {
      theme: "gammel",
      adjustdiv: "0",
      pYAxisName: "Lançamentos",
      sYAxisName: "Lucro",
      drawcustomlegendicon: "1",
      plottooltext: "$label, $seriesname: $dataValue",
      palettecolors: "#ED5E80,#2A8DEB",
      legendposition: "top",
      exportEnabled: "1",
      exportFileName: title,
      syncAxisLimits: "1",
      numberPrefix: "R$ ",
      //Disabling number scale compression
      formatNumberScale: "0",
      //Defining custom decimal separator
      decimalSeparator: ",",
      //Defining custom thousand separator
      thousandSeparator: ".",
    },

    categories: [
      {
        category: [
          { label: "Jan" },
          { label: "Fev" },
          { label: "Mar" },
          { label: "Abr" },
          { label: "Mai" },
          { label: "Jun" },
          { label: "Jul" },
          { label: "Ago" },
          { label: "Set" },
          { label: "Out" },
          { label: "Nov" },
          { label: "Dez" },
        ],
        fontSize: "15px",
      },
    ],
    dataset: [
      {
        dataset: [
          {
            seriesname: "Despesa",
            data: mountData(data, "PAID"),
          },
          {
            seriesname: "Receita",
            data: mountData(data, "RECEIVE"),
          },
        ],
      },
    ],
    lineset: [
      {
        seriesname: "Lucro Operacional",
        showvalues: "0",
        color: "#FDCB50",
        anchorbgcolor: "#FDCB50",
        showanchors: "0",
        data: mountData(data, "PROFIT"),
      },
    ],
  };
  return dataSource;
};

const mountLabel = (data) => {
  const Arrylabel = [];
  if (data) {
    data.forEach((data) => {
      Arrylabel.push({
        label: data.monthDate,
      });
    });
  }
  return Arrylabel;
};

const mountData = (data, type, balance) => {
  const Arrylabel = [];

  switch (type) {
    case "PAID":
      if (data) {
        data.forEach((data) => {
          Arrylabel.push({
            value: data.expense,
          });
        });
      }
      break;
    case "RECEIVE":
      if (data) {
        data.forEach((data) => {
          Arrylabel.push({
            value: data.revenue,
          });
        });
      }
      break;
    case "PROFIT":
      if (data) {
        data.forEach((data) => {
          Arrylabel.push({
            value: data.profit,
          });
        });
      }
    case "PAID_BALANCE":
      if (data) {
        data.forEach((data) => {
          Arrylabel.push({
            value: data.expense * -1,
          });
        });
      }
    case "BALANCE":
      if (data) {
        data.forEach((data) => {
          Arrylabel.push({
            value: data.balance,
          });
        });
      }
      break;

    default:
      break;
  }

  return Arrylabel;
};

export const mountChartLine = (res, title) => {
  const data = [];
  const dateFormat = "MMM/YYYY";
  for (let index = 1; index < 13; index++) {
    if (index < 10) {
      const month = moment(moment().year() + "-0" + index).format(dateFormat);
      var name = month.substring(0, 3);
      const firstLetter = name.charAt(0);

      const firstLetterCap = firstLetter.toUpperCase();

      const remainingLetters = name.slice(1);

      const capitalizedWord = firstLetterCap + remainingLetters;
      const hasMonth = res.filter(
        (item) => item.duaDateMonth == capitalizedWord
      );
      var amount = 0;
      if (hasMonth.length == 1) {
        amount = hasMonth[0].amount;
      }
      data.push({
        label: capitalizedWord,
        value: amount,
      });
    } else {
      const month = moment(moment().year() + "-" + index).format(dateFormat);
      var name = month.substring(0, 3);
      const firstLetter = name.charAt(0);

      const firstLetterCap = firstLetter.toUpperCase();

      const remainingLetters = name.slice(1);

      const capitalizedWord = firstLetterCap + remainingLetters;
      const hasMonth = res.filter(
        (item) => item.duaDateMonth == capitalizedWord
      );

      var amount = 0;
      if (hasMonth.length == 1) {
        amount = hasMonth[0].amount;
      }
      data.push({
        label: capitalizedWord,
        value: amount,
      });
    }
  }

  let dataSource = {
    chart: {
      theme: "gammel",
      palettecolors: "#FDCB50",
      legendposition: "top",
      showvalues: "1",
      exportEnabled: "1",
      exportFileName: title,
      numberPrefix: "R$ ",
      //Disabling number scale compression
      formatNumberScale: "0",
      //Defining custom decimal separator
      decimalSeparator: ",",
      //Defining custom thousand separator
      thousandSeparator: ".",
    },

    data: data,
  };
  return dataSource;
};

const mountLabelValue = (data) => {
  const Arrylabel = [];
  if (data) {
    data.forEach((data) => {
      Arrylabel.push({
        label: data.duaDateMonth,
        value: data.amount,
      });
    });
  }
  return Arrylabel;
};

export const mountWaterFall = (res, title) => {
  let dataSource = {
    chart: {
      theme: "gammel",
      numberprefix: "R$",
      showsumatend: "0",
      exportEnabled: "1",
      showvalues: "1",
      exportFileName: title,
      numberPrefix: "R$ ",
      //Disabling number scale compression
      formatNumberScale: "0",
      //Defining custom decimal separator
      decimalSeparator: ",",
      //Defining custom thousand separator
      thousandSeparator: ".",
    },

    data: mountLabelValueWaterFall(res),
  };
  return dataSource;
};

const mountLabelValueWaterFall = (data) => {
  const Arrylabel = [];
  if (data) {
    data.forEach((data) => {
      let color = data.total > 0 ? "#2A8DEB" : "#ED5E80";
      Arrylabel.push({
        label: data.grupo,
        value: data.total,
        color: color,
      });
    });
  }
  return Arrylabel;
};

export const mountChartMultLine = (res, title, balance) => {
  let dataSource = {
    chart: {
      theme: "gammel",
      adjustdiv: "0",
      drawcustomlegendicon: "1",
      plottooltext: "$label, $seriesname: $dataValue",
      palettecolors: "#ED5E80,#2A8DEB,#FDCB50",
      legendposition: "top",
      exportEnabled: "1",
      exportFileName: title,
    },

    categories: [
      {
        category: mountLabel(res),
        fontSize: "15px",
      },
    ],

    dataset: [
      {
        seriesname: "Despesa",
        data: mountData(res, "PAID_BALANCE"),
      },
      {
        seriesname: "Receita",
        data: mountData(res, "RECEIVE"),
      },
      {
        seriesname: "Ponto de equilíbrio",
        data: mountData(res, "BALANCE", balance),
      },
    ],
  };
  return dataSource;
};
